import React, { useCallback, useEffect, useState } from 'react'

import { WebViewerInstance } from '@pdftron/webviewer'

import { Coordinates } from '../../type'
import { getCoordinatesFromEvent } from '../../utils'

import { CrossMarker } from './CrossMarker.component'
import { MarkersOverlay } from './MarkersOverlay.component'

interface MarkerPlacementProps {
  containerRef: React.MutableRefObject<WebViewerInstance | null>
  markerContainer: HTMLElement | null
  pageNumber: number
  canEdit?: boolean
  onAdd: (coordinates: Coordinates) => void
}

export const MarkerPlacement: React.FC<MarkerPlacementProps> = ({
  containerRef,
  markerContainer,
  pageNumber,
  canEdit = true,
  onAdd,
}) => {
  const [mousePosition, setMousePosition] = useState<Coordinates | undefined>(undefined)

  const handleMouseMove = useCallback(
    (event: MouseEvent) => {
      if (!markerContainer) return

      const coordinates = getCoordinatesFromEvent(event, containerRef, pageNumber)
      if (!coordinates) return

      setMousePosition({
        x: coordinates.x,
        y: coordinates.y,
      })
    },
    [containerRef, markerContainer, pageNumber],
  )

  const handleClick = useCallback(
    (event: MouseEvent) => {
      if (!markerContainer) return

      const coordinates = getCoordinatesFromEvent(event, containerRef, pageNumber)
      if (!coordinates) return

      onAdd({
        x: coordinates.x,
        y: coordinates.y,
      })
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [containerRef, markerContainer, pageNumber],
  )

  useEffect(() => {
    if (!markerContainer) return

    markerContainer.addEventListener('mousemove', handleMouseMove)
    markerContainer.addEventListener('click', handleClick)

    return () => {
      markerContainer.removeEventListener('mousemove', handleMouseMove)
      markerContainer.removeEventListener('click', handleClick)
    }
  }, [markerContainer, handleMouseMove, handleClick])

  if (!canEdit) return null

  if (!mousePosition) return <MarkersOverlay />

  return <CrossMarker x={mousePosition.x} y={mousePosition.y} />
}
